import React from "react";
import { Col, Row } from "antd";

function CardHeader(props) {
    return (
        <Row style={{ display: "flex", alignItems: "center" }}>
            <Col span={12}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                        <h2 className={"dados-header"}>Administração e pessoas</h2>
                    </div>
                </div>
            </Col>
            <Col span={12}>

            </Col>
        </Row>
    )
}

export default CardHeader;
